const LOCALE_SEGMENT_PATTERN = /^(en|es|fr)$/i;

const getWindowPathname = (): string => {
  return typeof window !== 'undefined' && window.location ? window.location.pathname : '/';
};

export const getCurrentLocalePathPrefix = (pathname: string = getWindowPathname()): string | null => {
  const firstSegment = pathname.split('/').filter(Boolean)[0];

  if (!firstSegment || !LOCALE_SEGMENT_PATTERN.test(firstSegment)) {
    return null;
  }

  return `/${firstSegment.toLowerCase()}`;
};

const hasLocalePathPrefix = (path: string): boolean => {
  const firstSegment = path.split(/[/?#]/).filter(Boolean)[0];
  return Boolean(firstSegment && LOCALE_SEGMENT_PATTERN.test(firstSegment));
};

export const withCurrentLocalePrefix = (url: string, currentPathname: string = getWindowPathname()): string => {
  if (!url) {
    return url;
  }

  // Absolute (http:, https:, mailto:) or protocol-relative (//cdn...)
  if (/^([a-z][a-z0-9+.-]*:|\/\/)/i.test(url)) {
    return url;
  }

  // Hash-only / query-only (stay on current page)
  if (url.startsWith('#') || url.startsWith('?')) {
    return url;
  }

  // Only rewrite root-relative paths (widget params like `/carrinho`)
  if (!url.startsWith('/')) {
    return url;
  }

  const localePrefix = getCurrentLocalePathPrefix(currentPathname);
  if (!localePrefix) {
    return url;
  }

  if (hasLocalePathPrefix(url)) {
    return url;
  }

  return `${localePrefix}${url}`;
};
